import { Link } from 'expo-router';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Pressable, Text, tokens } from '@fhs/ui';
import { ServiceMode, useServiceModeContext } from 'state/service-mode';
import { useUIContext } from 'state/ui';
import { useFlag } from 'utils/launchdarkly';

export const DeliveryFeeNoticeBar = () => {
  const { formatMessage } = useIntl();
  const { serviceMode, deliveryFees } = useServiceModeContext();
  const { formatCurrencyForLocale: currencyFormatter } = useUIContext();
  const enableDeliveryFeeOnServiceModeBar = useFlag('show-delivery-fee-on-service-mode-bar');

  const isVisible =
    enableDeliveryFeeOnServiceModeBar &&
    serviceMode === ServiceMode.DELIVERY &&
    Boolean(deliveryFees?.deliveryTotalFee);

  if (!isVisible) {
    return null;
  }

  const deliveryFee = currencyFormatter(deliveryFees?.deliveryTotalFee ?? 0);
  const deliveryTermsUrl = formatMessage({ id: 'routes.deliveryTerms' });

  return (
    <View style={styles.container} accessibilityRole="text">
      <Text style={styles.text}>
        {deliveryFee} Delivery Fee (Per Order). Terms apply.{' '}
      </Text>
      <Link href={deliveryTermsUrl} asChild>
        <Pressable accessibilityRole="link" accessibilityLabel="See details">
          <Text style={[styles.text, styles.linkText]}>See details</Text>
        </Pressable>
      </Link>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
    flexDirection: 'row',
    height: 48,
    justifyContent: 'center',
    paddingHorizontal: 16,
    width: '100%',
  },
  text: {
    color: tokens.colors.$blackOpacity75,
    fontSize: 16,
    lineHeight: 20,
    textAlign: 'center',
  },
  linkText: {
    textDecorationLine: 'underline',
  },
});
